// extracted by mini-css-extract-plugin
export default {"businessName":"BusinessName_businessName__7FeMY","historyBtn":"BusinessName_historyBtn__57cUy","companyHome":"BusinessName_companyHome__SMRbi"};